import {Routes, Router, RouterModule, ExtraOptions} from "@angular/router";
import {HomePageComponent} from "./homepage/homepage.component";
import {SigninComponent} from "./signin/signin.component";
import {SignupComponent} from "./signup/signup.component";
import {environment} from "../environments/environment";
import {CareersComponent} from "./careers/careers.component";
/**
 * Created by davide on 15/03/2017.
 */

const tracing = environment.production == true ? false : true;

const MAIN_APP_ROUTES : Routes= [
  {
    path: '',
    pathMatch: 'full',
    component: HomePageComponent
  },
  {
    path: 'careers',
    pathMatch: 'full',
    component: CareersComponent
  },
  {
    path: 'signin',
    pathMatch: 'full',
    component: SigninComponent
  },
  {
    path: 'signup',
    pathMatch: 'full',
    component: SignupComponent
  }
];

export const ROUTE_MODULES = RouterModule.forRoot(
  MAIN_APP_ROUTES,
   {enableTracing: tracing , useHash:true}
);



// WEBPACK FOOTER //
// ./src/app/app.routing.ts